var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"waiver",attrs:{"id":"onerisk-waiver-container"}},[_c('div',{staticClass:"one-risk__window"},[_c('iframe',{attrs:{"id":"one-risk__iframe","src":_vm.oneRiskUrl,"title":"Sign Waiver"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }